import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Submissions from '../components/Submissions.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        redirect: {
            name: "Home"
        }
    },
    {
        path: '/submissions',
        name: 'Submissions',
        component: Submissions,
        props: true

    }, {
        path: '/home',
        name: 'Home',
        component: Home

    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router